import { acceptableImageFormat } from '../constants/FilterDataValues';
import { errorMsg } from '../constants/messages';
import { Rule } from 'antd/lib/form';

const HomepageArticleFormData = [
  {
    title: 'Homepage Article Details',
    name: 'id',
    label: 'Id',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Id', enableSort: false, allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: false,
  },
  {
    name: 'name',
    label: 'Name',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Name', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'description',
    label: 'Description',
    fieldType: {
      name: 'textarea',
      maxLength: 160,
    },
    required: true,
    errorMsg: errorMsg,
    placeholder: 'Enter description (maximum 160 characters)',
    maxLength: 160,
    validateFirst: true,
    validateTrigger: ['onChange', 'onBlur', 'onSubmit'],
    rules: [
      {
        max: 160,
        message: 'Description cannot exceed 160 characters',
      },
      {
        validator: (_rule: Rule, value: string) => {
          if (!value) return Promise.resolve();

          if (value.length > 160) {
            return Promise.reject(
              new Error(`Description cannot exceed 160 characters (current: ${value.length})`)
            );
          }
          return Promise.resolve();
        },
      },
    ],
    tableMeta: { title: 'Description' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'url',
    label: 'Image url',
    fieldType: {
      name: 'aboutPageOurTeamFile',
      accept: acceptableImageFormat,
      maxCount: 1,
      allowImageCropping: true,
    },
    placeholder: 'Click here to select',
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Image url',
      enableSort: false,
      allowAddRecordClick: false,
      columnType: 'image',
    },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'linkedService',
    label: 'Service',
    fieldType: {
      name: 'text',
    },
    placeholder: 'Enter service name',
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Service',
      enableSort: false,
      allowAddRecordClick: true,
      columnType: 'text',
    },
    isTableHeader: true,
    isAccordian: true,
    readonly: false,
    default: '',
  },
  {
    name: 'externalLink',
    label: 'External Link',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'External Link',
      allowAddRecordClick: true,
      columnType: 'link',
    },
    isTableHeader: true,
    isAccordian: true,
    default: '',
    placeholder: 'Enter the external URL (e.g., https://example.com)',
  },
];

export { HomepageArticleFormData };
export default HomepageArticleFormData;
